<template>
  <div>
    <div class="header">
      <div class="header-info">
        <ym-img class="header-title"
                :src="require('@/assets/img/group_buy/title.png')"
                alt="限时拼团"
        />
        <ym-button class="rule-btn"
                   size="small"
                   type="text"
                   @click="handleShowRule"
        >
          规则详情
        </ym-button>
      </div>
      <div class="count-down"
           v-if="showCountdown"
      >
        还剩
        <count-down :start="startTime"
                    :end="endTime"
        />
      </div>
    </div>
    <center-popup class="rule-popup"
                  :show.sync="showRulePopup"
                  title="规则详情"
    >
      <div class="rule-content"
           v-html="rule"
      ></div>
    </center-popup>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import CountDown from '@/components/CountDown';
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'ProductDetailGroupBuyBlockHeader',
    components: {
      'ym-button': Button,
      CountDown,
      CenterPopup,
    },
    data() {
      return {
        showRulePopup: false,
      };
    },
    props: {
      rule: {
        type: String,
        required: true,
      },
      startTime: {
        type: Number,
        required: true,
        default: 0,
      },
      endTime: {
        type: Number,
        required: true,
        default: 0,
      },
      showCountdown: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleShowRule() {
        this.showRulePopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .header {
    height: 80px;
    padding: 0 @size-medium;
    line-height: 1;
    color: @group-buy-header-color;
    background-blend-mode: overlay;
    background-image: @gradient-highlight-secondary;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-info {
    align-self: stretch;
    display: flex;
    align-items: center;
  }

  .header-title {
    flex-shrink: 0;
    display: inline-block;
    width: 144px;
    margin-top: @size-extra-small / 2;
  }

  .rule-btn {
    font-size: @font-size-extra-extra-small;
    color: inherit;
    opacity: .8;
  }

  .rule-popup {
    width: 630px;
  }

  .rule-content {
    text-align: left;
    font-size: @font-size-small;
    line-height: 2;
    padding: @size-base;
    color: @color-text-light;
    max-height: 670px;
    overflow: scroll;
    word-break: break-word;
  }

  .count-down {
    display: flex;
    align-items: center;
    align-self: stretch;
  }
</style>
